import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Footer from '../components/Footer';
import '../styles/Home.css';

function Home() {
  const [videoUrl, setVideoUrl] = useState(null);

  useEffect(() => {
    // Try to load the video from public folder
    setVideoUrl('/bg.mov');
  }, []);

  return (
    <div className="home-page">
      <section className="home">
        <header className="home-header">
          <nav>
            <RouterLink to="/">LoDis Signals</RouterLink>
            <ul>
              <li><RouterLink to="/">Home</RouterLink></li>
              <li><RouterLink to="/info">Info</RouterLink></li>
              <li><RouterLink to="/signals-firmware">Firmware</RouterLink></li>
              <li><RouterLink to="/orders">Orders</RouterLink></li>
            </ul>
          </nav>
        </header>
        <div className="home-body">
          <div className="home-content">
            <h1>Long Distance<br/>Low-Power<br/>Low-Cost<br/><span>Lo-Dis</span></h1>
            <p>Lo-Dis is a low power, wireless signal and dispatching system capable of all-day operation for your backyard railroad.</p>
            <RouterLink to="/info" className="cta-button">
              <span>Get Started</span><i></i>
            </RouterLink>
          </div>
        </div>
        <div className="social-icons">
          <a href="https://neols-lodis.web.app" target="_blank" rel="noopener noreferrer">NEOLS - Live Status</a>
        </div>
        {videoUrl && (
          <video src={videoUrl} className="bg-video" autoPlay loop playsInline muted></video>
        )}
        <span className="overlay"></span>
      </section>
      <Footer />
    </div>
  );
}

export default Home;
